import { render, staticRenderFns } from "./configInfo-add.vue?vue&type=template&id=1c9eec5c&scoped=true"
import script from "./configInfo-add.vue?vue&type=script&lang=js"
export * from "./configInfo-add.vue?vue&type=script&lang=js"
import style0 from "./configInfo-add.vue?vue&type=style&index=0&id=1c9eec5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9eec5c",
  null
  
)

export default component.exports